module.exports = __webpack_public_path__ + "media/images/admin/icons/music-cd6da382f3545c9a8a311af060e6238e.svg";